(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("crossDomainUtils", [], factory);
	else if(typeof exports === 'object')
		exports["crossDomainUtils"] = factory();
	else
		root["crossDomainUtils"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 